var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 35,
    rx: 4.57143,
    fill: "#959AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3691 13.0059L19.2441 6.88094C19.1627 6.79971 19.0662 6.7353 18.96 6.69138C18.8538 6.64747 18.7399 6.62491 18.625 6.625H8.125C7.66087 6.625 7.21575 6.80937 6.88756 7.13756C6.55937 7.46575 6.375 7.91087 6.375 8.375V27.625C6.375 28.0891 6.55937 28.5342 6.88756 28.8624C7.21575 29.1906 7.66087 29.375 8.125 29.375H23.875C24.3391 29.375 24.7842 29.1906 25.1124 28.8624C25.4406 28.5342 25.625 28.0891 25.625 27.625V13.625C25.6251 13.5101 25.6025 13.3962 25.5586 13.29C25.5147 13.1838 25.4503 13.0873 25.3691 13.0059ZM19.5 9.61203L22.638 12.75H19.5V9.61203ZM23.875 27.625H8.125V8.375H17.75V13.625C17.75 13.8571 17.8422 14.0796 18.0063 14.2437C18.1704 14.4078 18.3929 14.5 18.625 14.5H23.875V27.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/imageUpload.d8c987900cb725aee1e728f7b3218ffc.svg";
export { ForwardRef as ReactComponent };